import * as React from "react";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
import { useTranslation, useCategories } from "@elevio/kb-kit/lib/hooks";
import * as Search from "@elevio/kb-kit/lib/components/search";
import * as Categories from "@elevio/kb-kit/lib/components/categories";
import { getAssetURL } from "@elevio/kb-kit/lib/utils/globals";
import PageLayout from "../components/layouts/Page";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { MainSection, GridContainer, GridItem, } from "../components/layouts/Main";
import ArticleList from "../components/ArticleList";
import Breadcrumb from "../components/PageBreadcrumbs";
import { fetchAgencyFlags } from "../requests/agency-flags";
import { privateSubmissionUrl } from "../utils/privateSubmissionUrl";
export const brandLogo = `${window.assetsLocation}/images/logo-top.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.jpg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const getHeader = () => {
    const { t } = useTranslation();
    return (<Header hideSearch breadcrumbs={<div id="breadcrumbs-header-wrapper" className="breadcrumbs-header-wrapper">
          <Breadcrumb className="breadcrumbs-header"/>
        </div>}>
      <h1>
        <Trans i18nKey="home.welcome">
          How can we assist?
        </Trans>
      </h1>
      <Search.Input placeholder={t("search.placeholder", "Search help articles...")} data-testid="search-input" className="hero-search search-bar"/>
    </Header>);
};
const openPrivateSubmission = (path) => {
    const url = privateSubmissionUrl(path);
    if (!url) {
        return;
    }
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
        newWindow.opener = null;
    }
};
const AGENCY_ID = 91;
const HomePage = () => {
    useCategories();
    const [showViewAllRequests, setShowViewAllRequests] = React.useState(false);
    React.useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("create");
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("listing");
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("public-map");
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        {/* <div className="ask-arvada-logo-wrapper">
          <img className="ask-arvada-logo" src={brandShowcaseUrl} alt="ask-agency-logo-wrapper-image"/>
        </div> */}
        <section className="button-container button-container--three">
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleSubmitRequest}>
              <img src={getAssetURL("images/request.svg")} alt="request icon" aria-hidden/>
              Submit a Request
            </button>
          </div>
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewMyRequests}>
              <img src={getAssetURL("images/inbox.svg")} alt="inbox icon" aria-hidden/>
              View My Requests
            </button>
          </div>
          {showViewAllRequests ? (<div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                <img src={getAssetURL("images/map.svg")} alt="map icon" aria-hidden/>
                View All Requests
              </button>
            </div>) : null}
        </section>
        <GridContainer>
          <Categories.Loop>
            <GridItem>
              <ArticleList />
            </GridItem>
          </Categories.Loop>
        </GridContainer>
        {/* Code to show subcategories and there artice listing. Maybe required in the future. */}
        {/* <GridContainer>
          {categories.map(category => (
            <Categories.Loop parentCategoryId={category && category.id}>
              <GridItem>
                <ArticleList />
              </GridItem>
            </Categories.Loop>
          ))}
        </GridContainer> */}
      </MainSection>
    </PageLayout>);
};
export default HomePage;
